export const uniqueItems = <T>(items: T[]) => {
  return Array.from(new Set(items));
};
